<mat-menu #menu xPosition="before" (menuOpened)="opened()">
  <div class="menu-title">{{ 'Settings' | translate }}</div>
  <button mat-menu-item (click)="goToDevices()">
    <mat-icon>videocam</mat-icon>
    <span>{{ 'Devices' | translate }}</span>
    @if (alertBadge$ | async; as alertCount) {
      <span class="count-badge">{{ alertCount }}</span>
    }
  </button>
  @if (isExecutive$ | async) {
    <button mat-menu-item (click)="goToUsers()">
      @if (missingAlertRecipient$ | async) {
        <span class="attention-dot" [matTooltip]="'No alert recipients set' | translate"></span>
      }
      <mat-icon>group</mat-icon>
      <span>{{ 'Users' | translate }}</span>
    </button>
  }
  <mat-divider></mat-divider>
  <button mat-menu-item [matMenuTriggerFor]="themeMenu">
    <mat-icon fontSet="material-icons-outlined">dark_mode</mat-icon>
    <span>{{ 'Theme' | translate }}</span>
    <span class="current-value">{{ currentTheme().label | translate }}</span>
  </button>
  @if (showInstall$ | async) {
    <button mat-menu-item (click)="installPwa()">
      <mat-icon>download</mat-icon>
      <span>{{ 'Install App' | translate }}</span>
    </button>
  }
</mat-menu>

<mat-menu #themeMenu>
  @for (theme of themes; track theme.mode) {
    <button mat-menu-item (click)="themeService.setMode(theme.mode)">
      <mat-icon>{{ theme.mode === themeService.mode() ? 'check' : '' }}</mat-icon>
      <span>{{ theme.label | translate }}</span>
    </button>
  }
</mat-menu>
